// Mock-Daten für IT-Supervision Landing Page

export const mockData = {
  hero: {
    title: "Supervision für IT-Teams",
    subtitle: "Raum für Klarheit, Zusammenarbeit und Wirksamkeit im IT-Alltag.",
    cta: "Jetzt unverbindliches Gespräch anfragen",
    trustLine: "Vertraulich • Praxisnah • Lösungsorientiert"
  },
  
  challenges: [
    "Hohe Taktung, Incident-Druck, 24/7-Bereitschaften",
    "Schnittstellen zwischen Dev, Ops, Security, Fachbereichen",
    "Priorisierung, Ticket-Overload, Kontextwechsel",
    "Wissenssilos, Remote-/Hybrid-Kommunikation, Übergaben",
    "Reibungen in Rollen, Verantwortlichkeiten und Erwartungen",
    "Fehlende Zeit für Reflexion und strukturierten Austausch"
  ],
  
  benefits: [
    {
      title: "Konflikte klären",
      description: "Spannungen abbauen und konstruktive Lösungen finden"
    },
    {
      title: "Zusammenarbeit verbessern",
      description: "Kommunikationswege optimieren und Schnittstellen stärken"
    },
    {
      title: "Rollen schärfen",
      description: "Verantwortlichkeiten klar definieren und Erwartungen abstimmen"
    },
    {
      title: "Qualität erhöhen",
      description: "Übergaben und Serviceprozesse nachhaltig verbessern"
    },
    {
      title: "Resilienz stärken",
      description: "Gesundheit und Belastbarkeit im Team fördern"
    },
    {
      title: "Lernkultur etablieren",
      description: "Aus Erfahrungen systematisch lernen und Wissen teilen"
    }
  ],
  
  formats: [
    {
      title: "Teamsupervision",
      description: "Regelmäßige Reflexion realer Situationen im Team.",
      details: "Ideale Teamgröße: 6-10 Personen | Frequenz: alle 4-6 Wochen"
    },
    {
      title: "Fallsupervision",
      description: "Bearbeitung konkreter Fälle (z. B. Incident, Eskalation, Kundenfall).",
      details: "Dauer: 90-120 Minuten | Vor Ort oder Remote"
    },
    {
      title: "Leitungs-/Führungssupervision",
      description: "Sparring für IT-Leitung, Team-/Projektleitung.",
      details: "Einzelformat oder kleine Leitungsrunden"
    },
    {
      title: "Intervision (angeleitet)",
      description: "Aufbau interner Peer-Formate mit methodischer Begleitung.",
      details: "Befähigung zur selbstständigen Reflexion"
    }
  ],
  
  topics: [
    {
      title: "On-Call/Incident-Review",
      description: "Aus Fehlern systemisch lernen statt Schuldige suchen"
    },
    {
      title: "Dev-Ops-Handovers",
      description: "Verantwortlichkeiten und Schnittstellen klären"
    },
    {
      title: "Service Desk & 2nd/3rd Level",
      description: "Priorisierung, Kommunikation, Eskalationswege"
    },
    {
      title: "Security vs. Delivery",
      description: "Spannungsfelder konstruktiv moderieren"
    },
    {
      title: "Projekt/Run-Balance",
      description: "Realistische Planung, Kapazitäten & Fokus"
    },
    {
      title: "Wissensmanagement",
      description: "Übergaben, Dokumentation, Bus-Faktor reduzieren"
    }
  ],
  
  process: [
    {
      step: "01",
      title: "Vorgespräch & Zielbild",
      description: "Ausgangslage, Ziele, Rollen, Rahmen klären."
    },
    {
      step: "02",
      title: "Kick-off mit Team",
      description: "Verabredungen, Erwartungen, Arbeitsprinzipien."
    },
    {
      step: "03",
      title: "Regeltermine",
      description: "Supervisionseinheiten nach vereinbartem Takt."
    },
    {
      step: "04",
      title: "Review & Next Steps",
      description: "Wirkungen reflektieren, Anpassungen vereinbaren."
    }
  ],
  
  faqs: [
    {
      question: "Wie unterscheidet sich Supervision von Coaching?",
      answer: "Supervision fokussiert die gemeinsame Reflexion realer Arbeitssituationen mit dem Team; Coaching richtet sich eher an Einzelpersonen/Führungskräfte."
    },
    {
      question: "Brauchen wir Vorwissen?",
      answer: "Nein. Der Rahmen wird gemeinsam im Kick-off abgestimmt."
    },
    {
      question: "Gibt es Protokolle?",
      answer: "Vereinbarungen und nächste Schritte werden dokumentiert; Inhalte aus vertraulichen Teilen werden nicht personenbezogen festgehalten."
    },
    {
      question: "Remote möglich?",
      answer: "Ja, nach Vereinbarung. Hybrid-Formate sind ebenfalls umsetzbar."
    },
    {
      question: "Wie starten wir?",
      answer: "Mit einem 30-minütigen Vorgespräch zur Zielklärung und Organisation."
    }
  ],
  
  targetGroups: [
    "IT-Leitung, Team-/Projektleitungen",
    "Dev-, Ops-, SRE-, Security-, Service-Desk-Teams",
    "Cross-funktionale Projekt- und Produktteams"
  ],
  
  results: [
    "Klare Verantwortlichkeiten und abgestimmte Prozesse",
    "Vereinbarte Spielregeln für Kommunikation & Übergaben",
    "Verbesserte Zusammenarbeit über Schnittstellen hinweg",
    "Gelerntes aus Incidents systematisch nutzbar gemacht"
  ]
};
